import SmartDashboard from "@/components/dashboard/SmartDashboard";
import Seo from "@/components/seo/Seo";

const Dashboard = () => {
  return (
    <>
      <Seo title="Dashboard" description="Your personal Grade Test Pro dashboard." canonicalPath="/dashboard" noindex />
      <SmartDashboard />
    </>
  );
};

export default Dashboard;
